<template>
    <div ref="goods-wrap" class="goods scrollbarNone" @scroll="handleScroll">
        <WxAuthorization :redirectUri="redirectUri" openidKey="vip-coach-openid" unionidKey="vip-coach-unionid" />
        <van-sticky>
            <div class="bar">
                <div v-if="isLogin" class="account">
                    <div class="account-phone">当前账号：{{wxUserInfo.phone | mobileFilter}}</div>
                    <div class="account-toggle" @click="loginStatus = true">切换手机号</div>
                </div>
                <div class="app">
                    <div class="app_text">学车考驾照就来斑斑</div>
                    <img src="@/assets/vipCoach/v2/bbjdlogo.png">
                    <div class="app_flex"></div>
                    <div class="app_button" @click="linkApp">立即下载></div>
                </div>
            </div>
        </van-sticky>
        <div class="wrap">
            <template v-if="goodsCode && codeList[goodsCode]">
                <img class="bg" :src="require(`@/assets/vipGoods/${goodsCode}/${codeList[goodsCode].top}`)" alt="">
                <div class="current-subject" @click="currentSubject.status = true">学车进度：{{ currentSubject.name }}<img src="@/assets/vipCoach/v2/icon_kmxl.png"></div>
                <div v-if="goodsItems.length > 1" :key="currentSubject.subjectKey" class="item-menu scrollbarNone">
                    <div
                        v-for="(v,i) in goodsItems"
                        :key="i"
                        :class="[
                            'item-menu-content',
                            v.goodsCode === selectGoods.settingDto.goodsCode && 'active',
                            goodsItems.length > 3 && 'flex115'
                        ]"
                        @click="handleToggleGoods(v)">
                        <div class="title">{{ v.goodsName }}</div>
                        <div class="price">¥<b>{{ v.payConPrice }}</b>{{ v.effectiveDays|unit }}</div>
                        <div class="desc">{{ v.goodsDesc }}</div>
                        <div class="right-top-icon" v-if="v.warnTips">{{ v.warnTips }}</div>
                    </div>
                </div>
                <template v-for="(v,i) in codeList[goodsCode].list">
                    <!--其他组件判断-->
                    <component v-if="v.indexOf('c-') > -1" :key="`${componentsKey}_${i}`" :is="v" :cityCode="cityCode" :goodsCode="goodsCode" :initExamPlaceBatchId="examPlaceBatchId" :ref="v" @submit="(id) => handlePay(id)"/>
                    <!-- 剩下的图片 -->
                    <img :key="i" class="bg" :src="require(`@/assets/vipGoods/${v}`)" v-else-if="v.indexOf('ensure') === -1" alt=""/>
                    <!--过考保障判断 ensureFlag:单科有过考保障 ensureSubject套餐有过考保障-->
                    <template v-else-if="selectGoods.ensureFlag || (selectGoods.ensureSubject && selectGoods.containGoodsCode)">
                        <!-- ensureSubject 1:科目一 4:科目四 5:科目一+科目四 -->
                        <img v-if="selectGoods.ensureSubject && selectGoods.containGoodsCode" :key="'gkzb' + i" class="bg" :src="require(`@/assets/vipGoods/ensure-${selectGoods.ensureSubject}.png`)" />
                        <!-- 单科的状态下 并且显示过考保障 -->
                        <img v-else-if="!selectGoods.containGoodsCode && selectGoods.ensureFlag" :key="i" class="bg" :src="require(`@/assets/vipGoods/${v}`)" />
                    </template>
                </template>

                <c-essence :essenceList="pageDto.noneOpendSonSelectedDto.sonMicrocourseDtoList"/>

                <div class="question">
                    <img class="title" src="@/assets/vipGoods/cjwt.png" alt="">
                    <template v-for="(v,i) in codeList[goodsCode].question">
                        <template v-if="isShowEnsure(v)">
                            <div :key="i + 'label'" class="question-title" v-html="v.label"> </div>
                            <div :key="i + 'value'" class="question-content" v-html="v.value"></div>
                        </template>
                    </template>
                </div>

                <div class="footer">
                    <div v-if="goodsItems.length > 1" :key="currentSubject.subjectKey" v-show="isShowFooterGoods" class="footer-item-menu scrollbarNone">
                        <div
                            v-for="(v,i) in goodsItems"
                            :key="i"
                            :class="[
                                'footer-item-menu-content',
                                v.goodsCode === selectGoods.settingDto.goodsCode && 'active',
                                goodsItems.length > 3 && 'flex115'
                            ]"
                            @click="handleToggleGoods(v)">
                            <div class="title">{{ v.goodsName }}</div>
                            <div class="price">¥<b>{{ v.payConPrice }}</b>{{ v.effectiveDays|unit }}</div>
                            <div class="right-top-icon" v-if="v.warnTips">{{ v.warnTips }}</div>
                        </div>
                    </div>

                    <div :class="['submit', disabled && 'disabled']" @click="handlePay()">
                        <div class="price">
                            <span class="t1">￥{{ selectGoods.settingDto.payConPrice }}</span><span class="unit">{{ selectGoods.settingDto.effectiveDays|unit }}</span><span class="t2">原价¥{{ selectGoods.settingDto.payOrigPrice }}</span>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <Login v-if="loginStatus" @closed="loginStatus = false" @loginSuccess="init" />
        <Pay ref="pay"></Pay>
        <!-- 科目选择 -->
        <van-action-sheet v-model="currentSubject.status" :actions="currentSubject.items" @select="handleToggleSubject"></van-action-sheet>
        <div v-if="currentSubject.subject === -1" class="empty">
            <img src="@/assets/vipCoach/v2/picture_empty.png" />
            <div>商品已下架！</div>
        </div>
    </div>
</template>
<script>
// 公众号授权
import WxAuthorization from '../components/ghz-authorization.vue'
// 登录组件
import Login from '../components/login.vue'
import Pay from '../components/pay'
import { Toast, ActionSheet, Sticky, Dialog } from 'vant'
import { linkApp } from '../../utils'
import { getGzhH5GoodsItems, getGoodsDetail } from '../../api'
import codeList from './code.json'
import cExamRoom from './components/cExamRoom'
import cEssence from './components/cEssence'
import cLight from './components/cLight'

export default {
    name: 'vipCoachGoodsIndex',
    components: {
        [ActionSheet.name]: ActionSheet,
        [Sticky.name]: Sticky,
        WxAuthorization,
        Login,
        Pay,
        cEssence,
        cExamRoom,
        cLight
    },
    data () {
        return {
            subjectSwithFlag: false,
            cityCode: this.$route.query.cityCode,
            examPlaceBatchId: this.$route.query.examPlaceBatchId,
            redirectUri: window.location.href, // 微信授权认证重定向地址
            account: { phone: '' }, // 登录手机号
            loginStatus: false, // 登录状态
            componentsKey: Date.now(),
            currentSubject: { // 当前选中的科目
                items: [{ name: '科目一', value: 1 }, { name: '科目二', value: 2 }, { name: '科目三', value: 3 }, { name: '科目四', value: 4 }],
                status: false,
                name: '',
                subject: Number(this.$route.query.subject || 1)
            },
            goodsItems: [], // 对应科目商品列表
            examRoomVisible: false, // 考场信息显示隐藏
            codeList: codeList, // 对应商品配置表
            goodsCode: '', // 选中的商品code
            selectGoods: {}, // 选中的商品
            pageDto: {
                noneOpendSonSelectedDto: {
                    sonMicrocourseDtoList: []
                }
            },
            disabled: false, // 是否禁用购买
            isShowFooterGoods: false // 是否显示底部购买
        }
    },
    computed: {
        wxUserInfo () {
            return this.$store.getters['vipCoach/wxUser']
        },
        isLogin () { // 登录状态
            // phone token同时存在表示已登陆
            const { phone, token } = this.wxUserInfo
            return !!(phone && token)
        }
    },
    filters: {
        // 隐藏隐私
        mobileFilter (e) {
            return e.substr(0, 3) + '****' + e.substr(7)
        },
        // 获取单位
        unit (day) {
            const year = day / 365
            // 判断是否整数
            return Number.isInteger(year) ? `/${year}年` : `/${day}天`
        }
    },
    methods: {
        // 是否显示过考保障文案
        isShowEnsure ({ id }) {
            let showStatus = true
            // 有id 表示过考保障
            if (id) {
                // 区分当前商品是单科还是全科
                if (this.selectGoods.containGoodsCode && this.selectGoods.containGoodsCode.length) { // 存在 并且长度不为0 表示套餐
                    // ensureSubject字段不为0 表示已经开启过考保障
                    showStatus = !!this.selectGoods.ensureSubject
                } else { // 否则单科逻辑
                    showStatus = this.selectGoods.ensureFlag
                }
            }
            return showStatus
        },
        linkApp () {
            linkApp()
        },
        // 滚动监听 是否显示底部的商品菜单
        handleScroll (e) {
            this.isShowFooterGoods = e.target.scrollTop >= 600
        },
        // 切换选择科目
        handleToggleSubject ({ value }) {
            // 不是当前选中的科目 不请求
            if (value != this.currentSubject.subject) {
                this.currentSubject.subject = value
                this.currentSubject.subjectKey = Date.now()
                this.getGoodsItems()
            }
            // 关闭选择科目
            this.currentSubject.status = false
        },
        // 获取对应的科目商品信息
        getGoodsItems (subjectIndex) {
            return new Promise((resolve) => {
                Toast.loading({ duration: 0, mask: false, forbidClick: true })
                // 城市编码
                const { cityCode } = this.$route.query
                // 查询商品
                getGzhH5GoodsItems({
                    subjectSwithFlag: this.subjectSwithFlag, // 第一次不切科目 后面切
                    belongSubject: subjectIndex || this.currentSubject.subject,
                    cityCode,
                    virtuallyToken: this.wxUserInfo.token, // token
                    userMobile: this.wxUserInfo.phone // 学员手机号码
                }).then(({ result, status, message, code }) => {
                    Toast.clear()
                    if (status) {
                        if (!subjectIndex) { // 初始化查询的时候 不做任何处理
                            this.setConfigGoods(result)
                        }
                        resolve(result)
                    } else if (code === '-110') {
                        // token失效 重新刷新页面 重新登录
                        this.$store.dispatch('vipCoach/setWxPhone', {
                            phone: '',
                            token: ''
                        })
                        location.reload()
                    } else {
                        Toast(message)
                    }
                })
            })
        },
        // 设置商品信息
        setConfigGoods ({ noneOpendSonHookDtoList, noneOpendSonSelectedDto, servicePhone, sonMicrocourseDtoList, innerStuSubject }) {
            if (!this.subjectSwithFlag && innerStuSubject) {
                this.currentSubject.subject = innerStuSubject
            }
            // 这俩相等就是这个科目
            this.currentSubject.name = this.currentSubject.items.find(item => (item.value === this.currentSubject.subject)).name
            this.goodsItems = [ noneOpendSonSelectedDto.settingDto, ...(noneOpendSonHookDtoList || [])]
            this.selectGoods = noneOpendSonSelectedDto
            this.pageDto.noneOpendSonSelectedDto.sonMicrocourseDtoList = sonMicrocourseDtoList
            this.subjectSwithFlag = true // 开启切换科目
            this.setDocumentContent()
        },
        // 切换商品
        handleToggleGoods ({ goodsCode }) {
            if (this.selectGoods.settingDto.goodsCode !== goodsCode) {
                Toast.loading({ duration: 0, mask: false, forbidClick: true })
                // 查询选中的商品
                getGoodsDetail({
                    goodsCode
                }).then(({ result, status, message }) => {
                    Toast.clear()
                    if (status) {
                        this.selectGoods = result // 切换到选中的商品
                        this.pageDto.noneOpendSonSelectedDto.sonMicrocourseDtoList = result.sonMicrocourseDtoList
                        this.setDocumentContent()
                    } else {
                        Toast(message)
                    }
                })
            }
        },
        // 配置document元素
        setDocumentContent () {
            const { goodsCode, goodsName, effectiveDays } = this.selectGoods.settingDto
            // 设置对应的商品编码
            this.goodsCode = goodsCode
            // 设置标题
            document.title = goodsName
            this.$nextTick(() => {
                // 设置文案内容
                document.getElementById('buy-time').innerText = effectiveDays
                // 切换内容 滚动条回归原始位置
                this.$refs['goods-wrap'].scrollTop = 0
            })
        },
        // 购买商品前的逻辑
        prevPay () {
            return new Promise((resolve) => {
                const goods = this.selectGoods.settingDto
                getGoodsDetail({
                    goodsCode: goods.goodsCode
                }).then(({ status, message, result }) => {
                    if (status) {
                        const { settingDto } = result
                        // 权益比较 是否匹配
                        if (goods.effectiveDays === settingDto.effectiveDays && goods.payConPrice === settingDto.payConPrice) {
                            resolve(true)
                        } else { // 不匹配不给购买 重新提示
                            Dialog.alert({
                                title: '温馨提示',
                                message: '你购买的VIP商品权益发生变化，请重新购买',
                                theme: 'round-button',
                                className: 'vip-coach-btn',
                                confirmButtonText: '重新购买'
                            }).then(() => {
                                location.reload()
                            })
                            resolve(false)
                        }
                    } else {
                        Toast(message)
                    }
                })
            })
        },
        // 购买商品
        async handlePay (examPlaceBatchId = '') {
            // 有考场组件 没有选择考场视频 弹出来显示
            if (this.$refs['c-examRoom'] && this.$refs['c-examRoom'][0] && !examPlaceBatchId) {
                this.$refs['c-examRoom'][0].examRoomVisible = true
                return
            }
            // 购买前的判断 是否允许购买 权益是否变化等
            const isPay = await this.prevPay()
            if (isPay) {
                // 城市编码
                const { cityCode, userId } = this.$route.query
                const data = {
                    cityCode, // 城市编码
                    goodsCode: this.selectGoods.settingDto.goodsCode, // 商品编号
                    coachUserId: userId, // 教练id
                    examPlaceBatchId: examPlaceBatchId // 考场id
                }
                this.$refs['pay'].createOrder(data)
            }
        },
        // 初始化
        async init () {
            // 一次性查询科目一到科目四
            Promise.all([this.getGoodsItems(1), this.getGoodsItems(2), this.getGoodsItems(3), this.getGoodsItems(4)]).then(res => {
                // 遍历查询出来的内容
                for (let i = 0 ; i < res.length; i++) {
                    if (!res[i]) { // 查询出来为null 直接移除
                        this.currentSubject.items.splice(i, 1)
                        res.splice(i, 1)
                        i--
                    }
                }
                // 当前选中科目
                let index = this.currentSubject.items.findIndex(({value}) => (value === this.currentSubject.subject)) 
                // 有科目有商品
                if (res.length) {
                    // 当前参数的科目不存在 就默认第一个
                    if (index === -1) {
                        index = 0
                    }
                    // 设置科目
                    this.currentSubject.subject = this.currentSubject.items[index].value
                    // 设置内容
                    this.setConfigGoods(res[index])
                } else {
                    // 全部商品已关闭就 显示缺省
                    this.currentSubject.subject = -1
                }
            })
        }
    },
    mounted () {
        this.init()
    },
    activated () {
        const { cityCode, examPlaceBatchId } = this.$route.query
        this.cityCode = cityCode
        this.examPlaceBatchId = examPlaceBatchId
        this.componentsKey = Date.now()
        // 切换页面显示商品名称title
        if (this.selectGoods && this.selectGoods.settingDto) {
            document.title = this.selectGoods.settingDto.goodsName
        }
        this.$store.dispatch('setTimer')
    }
}
</script>
<style scoped lang="scss">
*{
    box-sizing: border-box;
}
.goods {
    height: 100%;
    overflow-y: auto;
}
.bar {
    position: relative;
    z-index: 100;
    .account{
        display: flex;
        align-items: center;
        padding: 8px 10px;
        background-color: #fff;
        &-phone{
            flex: 1;
            font-size: 15px;
        }
        &-toggle{
            padding: 0 13px;
            height: 27px;
            line-height: 27px;
            color:#53CB85;
            font-size: 15px;
            border: 1px solid #53CB85;
            border-radius: 13px;
        }
    }
    .app {
        padding: 9px 15px;
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        display: flex;
        align-items: center;
        background-color: rgba(0, 0, 0, 0.5);
        &_text {
            margin-right: 5px;
            color: #FFFFFF;
            font-size: 15px;
            font-weight: 600;
        }
        img {
            width: 24px;
            height: 24px;
        }
        &_flex {
            flex: 1;
        }
        &_button {
            width: 80px;
            height: 24px;
            line-height: 24px;
            color: #fff;
            font-size: 13px;
            background: #00CA84;
            border-radius: 12px;
            text-align: center;
            font-weight: 600;
        }
    }
}
.current-subject {
    margin: 10px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #000000;
    font-size: 15px;
    font-weight: 600;
    img {
        margin-left: 9px;
        width: 18px;
        height: 18px;
    }
}

.footer{
    position: sticky;
    bottom: -1px;
    z-index: 9;
    padding: 10px;
    background: #ffffff;
    .footer-item-menu{
        padding-top: 10px;
        display: flex;
        overflow: auto;
        .footer-item-menu-content{
            position: relative;
            box-sizing: border-box;
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 88px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #C0C1C4;
            text-align: center;
            line-height: 1;
            &.flex115 {
                flex: 0 0 115px;
            }
            .title{
                display: flex;
                line-height: 18px;
                align-items: flex-end;
                justify-content: center;
                font-weight: 600;
                color: #6A220D;
            }
            .price{
                margin: 5px 0 0 0;
                font-size: 15px;
                color: #6A220D;
            }
            .right-top-icon{
                position: absolute;
                background: #FEE068;
                border-radius: 2px 5px 2px 5px;
                font-size: 12px;
                font-weight: 600;
                color: #7F2500;
                padding: 3px 4px;
                transform: scale(0.83333);
                transform-origin: top right;
                top: -6px;
                right: 0px;
            }
        }
        .footer-item-menu-content+.footer-item-menu-content{
            margin: 0 0 0 5px;
        }
        .footer-item-menu-content.active{
            background: #212528;
            .title,.price{
                color: #FFFFFF;
            }
            &::after{
                content: ' ';
                position: absolute;
                right: -1px;
                bottom: -1px;
                width: 40px;
                height: 18px;
                background: url("~@/assets/vipGoods/yx2.png") no-repeat 100%/100%;
            }
            .right-top-icon{
                color: #FFFFFF;
                background: #FF5825;
            }
        }
    }
    .submit{
        position: relative;
        margin: 15px auto;
        width: 355px;
        height: 60px;
        background: url("~@/assets/vipGoods/ljkt.gif") no-repeat 100%/100%;
        .price{
            margin: 0 0 0 20px;
            position: absolute;
            transform: translateY(-50%);
            top: 50%;
        }
        .price .t1{
            font-size: 24px;
            font-weight: 600;
            color: #FFFFFF;
        }
        .price .unit {
            color: #fff;
            font-size: 15px;
        }
        .price .t2{
            font-size: 15px;
            color: rgba(255, 255, 255, 0.6);
            margin: 0 0 0 5px;
            text-decoration: line-through;
        }
    }
    .submit.disabled{
        background: url("~@/assets/vipGoods/icon_dban_zh.png") no-repeat 100%/100%;
    }
}
.tutorial{
    text-align: right;
    text-decoration: underline;
    padding: 15px 10px 18px 0;
    font-size: 13px;
    color: #A6431B;
}
.question{
    position: relative;
    width: 355px;
    background: #FFFFFF;
    border-radius: 5px;
    border: 3px solid #FF5825;
    margin: 26px auto 0;
    box-sizing: border-box;
    padding: 40px 15px 20px;
    .title{
        width: 184px;
        position: absolute;
        top: -21px;
        left: 100px;
    }
    .question-title{
        margin: 20px 0 0 0;
        font-size: 15px;
        padding: 0 0 0 25px;
        font-weight: 600;
        color: #864200;
        background: url("~@/assets/vipGoods/wt.png") no-repeat left/16px;
    }
    .question-content{
        word-break: break-all;
        white-space: break-spaces;
        margin: 10px 0 0 26px;
        font-size: 12px;
        color: #000000;
        line-height: 20px;
    }
}
.item-menu{
    display: flex;
    padding: 15px 10px 8px 10px;
    overflow: auto;
    .item-menu-content{
        position: relative;
        box-sizing: border-box;
        flex: 1;
        height: 135px;
        background: #FFFFFF;
        border-radius: 5px;
        border: 3px solid #CCCCCC;
        text-align: center;
        line-height: 1;
        &.flex115 {
            flex: 0 0 115px;
        }
        .title{
            display: flex;
            align-items: flex-end;
            justify-content: center;
            height: 48px;
            font-size: 18px;
            font-weight: 600;
            color: #000000;
        }
        .price{
            margin: 7px 0 0 0;
            font-size: 15px;
            font-weight: 600;
            color: #FF5050;
        }
        .price b{
            font-size: 24px;
        }
        .desc{
            margin: 7px 0 0 0;
            font-size: 13px;
            color: #A6431B;
        }
        .right-top-icon{
            position: absolute;
            padding: 3px 8px;
            background: #FEE068;
            border-radius: 2px 5px 2px 5px;
            margin: 0 0 0 5px;
            right: -3px;
            top: -10px;
            font-size: 12px;
            font-weight: 600;
            color: #7F2500;
        }
    }
    .item-menu-content+.item-menu-content{
        margin: 0 0 0 5px;
    }
    .item-menu-content.active{
        background: #FFF0EC;
        border: 3px solid #FF5825;
        &::after{
            content: ' ';
            position: absolute;
            right: -1px;
            bottom: -1px;
            width: 40px;
            height: 18px;
            background: url("~@/assets/vipGoods/yx.png") no-repeat 100%/100%;
        }
        .right-top-icon{
            color: #FFFFFF;
            background: #FF5825;
        }
    }
}
.bg{
    width: 100%;
}
.wrap{
    background: #FFF6E4;
}
.header{
    position: sticky;
    top: 0;
    z-index: 9;
    background: #ffffff;
    display: flex;
    align-items: center;
    padding: 13px 10px;
    .header-left,.header-right{
        display: flex;
        align-items: center;
        width: 100px;
        img{
            width: 24px;
        }
    }
    .header-right{
        justify-content: end;
        img+img{
            margin: 0 0 0 13px;
        }
    }
    .header-main{
        white-space: nowrap;
        text-align: center;
        flex: 1;
        font-size: 18px;
        font-weight: 600;
        color: #333333;
    }
}
.scrollbarNone {
    scrollbar-width: none;
    &::-webkit-scrollbar{
        display: none;
    }
}
.empty {
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: #999;
    font-size: 14px;
    img {
        width: 200px;
    }
}
</style>
